var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Progress from "../Partials/Progress";
export default function StepLayout(_a) {
    var children = _a.children, team = _a.team, branch = _a.branch, certificate = _a.certificate, form = _a.form;
    return _jsxs("div", __assign({ className: "md:flex md:flex-row-reverse" }, { children: [_jsx("div", __assign({ className: "md:w-3/4 lg:w-4/5" }, { children: children })), _jsx("div", __assign({ className: "md:w-1/4 lg:w-1/5 pr-8 pt-8 border-t mt-8 md:pt-0 md:mt-0 md:border-0" }, { children: _jsx(Progress, { team: team, branch: branch, certificate: certificate, step: form.data._step, onChange: function () { } }) }))] }));
}
